<template>
  <div class="assembly">
    <Header v-if="$store.getters.isLayout" />
    <div
      :class="[
        $store.getters.isLayout ? 'assembly-content' : 'assembly-content-height',
      ]"
    >
      <Bread v-if="$store.getters.isLayout" />
      <!-- <router-link to="/assembly/index">搜索结果</router-link> -->
      <!-- <div @click="btn">搜索结果</div> -->
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <Footer v-if="$store.getters.isLayout" v-show="$route.path != '/resourceLibrary/index'" />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Bread from "@/components/Bread.vue";
import Footer from "@/components/Footer.vue";
export default {
  data() {
    return {};
  },
  components: { Header, Bread, Footer },
  mounted() {
    console.log(this.$route);
  },
  methods: {
    btn() {
      this.$router.push("/assembly/index");
    },
  },
};
</script>
<style scoped lang='scss'>
.assembly {
  .assembly-content {
   min-height: calc(100vh - 270px);
    background: #f2f2f2;
  }
  .assembly-content-height{
    min-height: 100vh;
    background: #f2f2f2;
  }
}
</style>
